import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import { ALIGNMENT_TO_CLASS_MAP, DEFAULT_CONTAINER_CLASS, DEFAULT_ALIGNMENT_CLASS } from './PatternedImageRow.constants';
export function getImageId(image) {
  if (_isString(image)) {
    return image;
  }
  var _id = image._id;
  return _id;
}
export function getContainerClassName(pattern) {
  var alignment = pattern.alignment;
  var flexAlignmentClass = ALIGNMENT_TO_CLASS_MAP[alignment] || DEFAULT_ALIGNMENT_CLASS;
  return [DEFAULT_CONTAINER_CLASS, flexAlignmentClass].join(' ');
}
export function getContainerStyle(pattern) {
  var _ref = pattern || {},
    width = _ref.width,
    height = _ref.height;
  var style = {};
  if (_isNumber(width)) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      flex: width / 100
    });
  }
  if (_isNumber(height)) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      height: "".concat(height, "%")
    });
  }
  return style;
}
export function getImagePattern(image, images, patterns) {
  if (_isEmpty(patterns)) {
    return null;
  }
  var imageId = getImageId(image);
  if (!imageId) {
    return patterns[0];
  }
  var imageIndex = _findIndex(images, function (aImage) {
    return getImageId(aImage) === imageId;
  });
  if (imageIndex < 0) {
    return patterns[0];
  }
  return patterns[imageIndex % patterns.length];
}